import { Bath, ShowerHead, Toilet, Grab, DoorOpen, CircleEllipsis } from "lucide-react";
import ServicePageLayout from "@/components/ServicePageLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { useContent } from "@/content/ContentContext";

const APPLICATIONS = [
  {
    icon: Bath,
    title: "Bathroom Grab Rails",
    copy: "Support where it matters most — near baths, vanities and wet areas around the bathroom.",
  },
  {
    icon: ShowerHead,
    title: "Shower Grab Rails",
    copy: "Added stability when stepping in, standing and moving in the shower.",
  },
  {
    icon: Toilet,
    title: "Toilet Grab Rails",
    copy: "Support for sitting down and standing up, positioned to suit the space.",
  },
  {
    icon: Grab,
    title: "Wall-Mounted Support Rails",
    copy: "Straight, angled and folding rail options mounted securely to suit your needs.",
  },
  {
    icon: DoorOpen,
    title: "Entry / Access Areas",
    copy: "Extra support at doorways, entries and other transition points around the home.",
  },
  {
    icon: CircleEllipsis,
    title: "Other Areas",
    copy: "Hallways, kitchens, laundries, garages — anywhere additional support may be required.",
  },
];

export default function GrabRails() {
  const { get } = useContent();
  usePageMeta(
    get("meta_grab_title", "Grab Rails Perth | Supplied & Installed | Modify"),
    get("meta_grab_desc", "Grab rails supplied and professionally installed across Perth — bathrooms, showers, toilets and walls. Brick or stud, we plan the right fixing. Free quote.")
  );
  return (
    <ServicePageLayout
      pageTestid="grab-rails-page"
      eyebrow="Grab Rails — Perth, WA"
      title="GRAB RAILS SUPPLIED & PROFESSIONALLY INSTALLED"
      sub="Improve stability, confidence and safety around your home with professionally installed grab rails."
      heroImg="/images/grab-hero.jpg"
      heroAlt="Professionally installed grab rails in a Perth bathroom"
      enquiryTitle="NEED A GRAB RAIL INSTALLED?"
      enquiryCopy="Tell us what you need, send us a photo, and we'll help you find the right solution."
      service="Grab Rails"
      applicationsTitle="Where grab rails can help."
      applications={APPLICATIONS}
      note="Not every rail is suitable for every wall or situation. Get in touch and we'll help you find the right solution for your space and installation."
      galleryCategory="grab-rails"
      promo={{}}
      ctaTitle="READY TO MAKE YOUR HOME SAFER?"
      ctaLabel="ENQUIRE TODAY"
      heroCtaLabel="ENQUIRE TODAY"
    />
  );
}
